import axios from 'axios'
import React, { useState, useEffect, useCallback } from 'react'
import { LuPhoneIncoming, LuPhoneOutgoing, LuRotateCcw } from 'react-icons/lu'
import {
  Button,
  Form,
  FormField,
  Header,
  Image,
  Modal,
  ModalActions,
  ModalContent,
  ModalDescription,
  ModalHeader,
  Segment,
} from 'semantic-ui-react'

import history from '~/services/history'
import { useGlobalContext } from '../../contexts/GlobalContext'
import api from '../../services/api_v3'
import { Container } from './styles'

function formatPhone(phone) {
  // Remove tudo que não for número
  const phoneNumbers = phone.replace(/\D/g, '')

  // DDD + Celular (11 dígitos) → (31) 98765-4321
  if (phoneNumbers.length === 11) {
    return phoneNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }

  // DDD + Fixo (10 dígitos) → (31) 3456-7890
  if (phoneNumbers.length === 10) {
    return phoneNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  }

  // Celular sem DDD (9 dígitos) → 98765-4321
  if (phoneNumbers.length === 9) {
    return phoneNumbers.replace(/(\d{5})(\d{4})/, '$1-$2')
  }

  // Fixo sem DDD (8 dígitos) → 3456-7890
  if (phoneNumbers.length === 8) {
    return phoneNumbers.replace(/(\d{4})(\d{4})/, '$1-$2')
  }

  // Se tiver mais ou menos dígitos, retorna bruto
  return phoneNumbers
}

export default function ActiveTicket() {
  const { globalState } = useGlobalContext()
  const { dominio, user_basix } = globalState

  const [open, setOpen] = useState(false)
  const [numero, setNumero] = useState('')
  const [activeCalls, setActiveCalls] = useState([])

  // console.log({ dominio, user_basix })

  const abrirTicket = async ({ from, to, user, domain, callid }) => {
    try {
      const { data } = await axios.get(
        `https://devweb.cloudcom.com.br/chamada/${from}/${to}/${user}/${domain}/${callid}/ESTABLISHED`,
      )

      history.push('/dashboard')
    } catch (error) {
      console.error('Erro ao abrir ticket:', error)
    }
  }

  const fetchActiveCalls = useCallback(async () => {
    let { data } = await api.get(
      `/contact/domain/${dominio}/user/${user_basix}/activecalls`,
    )
    // setActiveCalls(
    //   data.filter(
    //     (call) => call.DOMINIO === dominio && call.USERNAME === user_basix,
    //   ),
    // )

    data = data.map((call) => {
      if (/\d{4}55\d{10,11}/.test(call.ORIGEM)) {
        call.ORIGEM = call.ORIGEM.replace(/^\d{4}/, '')
      }

      return call
    })

    data = data.sort((a, b) => {
      if (a.INT_CALLLOG_KEY > b.INT_CALLLOG_KEY) return 1
      if (a.INT_CALLLOG_KEY < b.INT_CALLLOG_KEY) return -1
      return 0
    })

    const uniqueList = data.filter((call) => call.VCH_XCID)

    let listUniqueByXcid = uniqueList.reduce((acc, current) => {
      const xcidExists = acc.some((item) => item.VCH_XCID === current.VCH_XCID)
      if (!xcidExists) {
        acc.push(current)
      }
      return acc
    }, [])

    listUniqueByXcid = listUniqueByXcid.map((call) => {
      const listaByXcid = data.filter((item) => item.VCH_XCID === call.VCH_XCID)

      console.log({
        call,
        listaByXcid,
      })

      call.ORIGEM = listaByXcid[0].ORIGEM
      call.DESTINO = listaByXcid[0].DESTINO
      call.USERNAME = listaByXcid[listaByXcid.length - 1].USERNAME

      return call
    })

    setActiveCalls(listUniqueByXcid)
  }, [dominio, user_basix])

  useEffect(() => {
    fetchActiveCalls()
  }, [fetchActiveCalls])

  return (
    <Container>
      <Segment color="blue" className="container-segment">
        <div className="ui buttons">
          <button
            type="button"
            className="ui button button-center-icons"
            onClick={() => {
              fetchActiveCalls()
            }}
          >
            <LuRotateCcw style={{ marginRight: 5 }} />
            Receptiva
            <LuPhoneIncoming style={{ marginLeft: 5 }} />
          </button>
          <div className="or" data-text="ou" />
          <button
            type="button"
            className="ui positive button button-center-icons"
            onClick={() => {
              setOpen(true)
            }}
          >
            Ativa
            <LuPhoneOutgoing style={{ marginLeft: 5 }} />
          </button>
        </div>
        <h4>Chamadas Ativas</h4>
        <table className="ui celled table">
          <thead>
            <tr>
              <th>Origem</th>
              <th>Destino</th>
              <th>Usuário</th>
              <th>Tipo</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {activeCalls.length > 0 ? (
              activeCalls.map((call) => (
                <tr key={call.CALLID}>
                  <td data-label="From">{call.ORIGEM}</td>
                  <td data-label="To">{call.DESTINO}</td>
                  <td data-label="Username">{call.USERNAME}</td>
                  <td data-label="Type">{call.INT_CALLTYPE}</td>
                  <td>
                    <button
                      className="ui blue button"
                      type="button"
                      onClick={() => {
                        abrirTicket({
                          from: call.ORIGEM,
                          to: call.DESTINO,
                          user: user_basix,
                          domain: dominio,
                          callid: call.VCH_XCID,
                        })
                      }}
                    >
                      Criar Ticket
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">Nenhuma chamada ativa</td>
              </tr>
            )}
            {/* <tr>
              <td data-label="Name">11961197559</td>
              <td data-label="Age">551135880866</td>
              <td data-label="Job">Eduardo</td>
              <td data-label="Job">Receptiva</td>
              <td>
                <button className="ui blue button" type="button">
                  Criar Ticket
                </button>
              </td>
            </tr>
            <tr>
              <td data-label="Name">2176389467</td>
              <td data-label="Age">551137115000</td>
              <td data-label="Job">Caio</td>
              <td data-label="Job">Ativa</td>
              <td>
                <button className="ui blue button" type="button">
                  Criar Ticket
                </button>
              </td>
            </tr>
            <tr>
              <td data-label="Name">1173603729</td>
              <td data-label="Age">551137115000</td>
              <td data-label="Job">Renata</td>
              <td data-label="Job">Ativa</td>
              <td>
                <button className="ui blue button" type="button">
                  Criar Ticket
                </button>
              </td>
            </tr> */}
          </tbody>
        </table>
      </Segment>

      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
        <ModalHeader>Iniciar Chamada Ativa</ModalHeader>
        <ModalContent>
          <Form>
            <FormField>
              <label htmlFor="did">Numero de destino</label>
              <input
                id="did"
                placeholder="Numero de destino"
                value={numero}
                onChange={(e) => {
                  // formatar o numero de telefone

                  setNumero(formatPhone(e.target.value))
                }}
              />
            </FormField>
          </Form>
        </ModalContent>
        <ModalActions>
          <Button color="black" onClick={() => setOpen(false)}>
            Fechar
          </Button>
          <Button
            content="Iniciar chamada"
            labelPosition="right"
            icon="checkmark"
            onClick={
              async () => {
                try {
                  await axios.get(`https://api.v3.cloudcom.com.br/contact/domain/${dominio}/user/${user_basix}/makecall/to/${numero.replace(/\D/g, '')}`)
                  setOpen(false)
                  history.push('/dashboard')
                } catch (error) {
                  alert(error?.response?.data?.error || error.message)
                }
              }
            }
            positive
          />
        </ModalActions>
      </Modal>
    </Container>
  )
}
